<template>
    <v-app>
        <v-navigation-drawer
            app
            v-model="sideNav"
            right
            temporary
            dark
            color="primary"
        >
            <v-list-item>
                <v-list-item-content class="text-right">
                    <v-list-item-title class="title">
                        <AppLogo />
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        by Greg Jacobs
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list
                nav
                dense
            >
                <v-list-item-group active-class="white--text darken-4">
                    <template v-for="(item, index) in menuItems">
                        <template v-if="!item.icon">
                            <v-divider :key="index"/>
                        </template>
                        <template v-else>
                            <v-list-item :key="index" :to="item.path">
                                <v-list-item-icon>
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                            </v-list-item>
                        </template>
                    </template>

                    <v-divider/>
                    <!-- todo: add user login authentication with firebase
                    <v-list-item v-if="userIsAuthenticated" @click="onLogout">
                        <v-list-item-icon>
                            <v-icon>mdi-exit-to-app</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item>
                    -->
                </v-list-item-group>
            </v-list>

            <template v-slot:append>
                <!-- todo: add user login authentication with firebase
                <v-list-item v-if="userIsAuthenticated" @click="onLogout">
                    <v-list-item-icon>
                        <v-icon>mdi-exit-to-app</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
                -->
                <v-list-item @click="fetchUpdatedData">
                    <v-list-item-icon>
                        <v-icon>mdi-download</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Update Data</v-list-item-title>
                </v-list-item>
            </template>
        </v-navigation-drawer>

        <v-app-bar
            app
            dark
            color="primary"
        >
            <router-link :to="{ name: 'Guess the Movie' }">
                <v-btn
                    depressed
                    dark
                    text
                    tile
                    class="pa-0"
                >
                    <AppLogo />
                </v-btn>
            </router-link>

            <v-spacer></v-spacer>

            <div>
                <v-btn
                    depressed
                    dark
                    text
                    tile
                    class="p-0"
                    @click="sideNav = true"
                >
                    <v-icon class="ms-auto">mdi-menu</v-icon>
                </v-btn>
            </div>
        </v-app-bar>

        <v-main>
            <v-container fluid fill-height>
                <v-layout class="align-center justify-center">
                    <transition name="fade" mode="out-in">
                        <div v-if="loading" key="data-is-fetching">
                            <v-btn
                                loading
                                plain
                                tile
                            />
                            Loading
                        </div>
                        <div v-else key="data-has-loaded" style="width:100%;">
                            <router-view></router-view>
                        </div>
                    </transition>
                </v-layout>
            </v-container>
        </v-main>

        <v-footer
            dark
            padless
            app
            color="primary"
        >
            <v-col
                class="text-center"
                cols="12"
            >
                &copy; {{ new Date().getFullYear() }} — <strong>Quote Master</strong>
                by
                <a href="https://www.gregjacobs.com" target="_blank" class="text-white" style="color:white!important;text-underline-offset:.2em;">
                    GregJacobs.com
                </a>
            </v-col>
        </v-footer>
    </v-app>
</template>

<script>
    import AppLogo from './components/AppLogo';
    import { routes } from './router';

    export default {
        components: {
            AppLogo,
        },

        data () {
            return {
                sideNav: false,
                menuItems: routes,
            }
        },

        computed: {
            loading() {
                return this.$store.getters.loading;
            }
        },

        methods: {
            fetchUpdatedData() {
                this.$store.dispatch('FETCH_GOOGLESHEET');
            }
        }
    };
</script>
